module.exports = __webpack_public_path__ + "img/student_logo.4cfb03e1.png";